/**
 * How the console names a person. The studio knows its people by Discord, so
 * the Discord display name leads; the name on the account (their real name, once
 * the profile is filed) moves to the quieter line beneath it. Someone with no
 * Discord name on file reads the way they always did.
 */
interface Named {
  discordName?: string | null
  name: string | null
  email: string
}

/** The top line: Discord first, then the account's name, then the address. */
export const personName = (person: Named): string => person.discordName ?? person.name ?? person.email

/** The real name for the line beneath — only when Discord took the top line. */
export const realName = (person: Named): string | null =>
  person.discordName && person.name ? person.name : null

/**
 * The beneath line's opening words: the real name, when it exists. The email
 * stays off — the Discord name and the real name already say who it is, and
 * the address only crowded the line. It still leads when it is all we have.
 */
export const personDetails = (person: Named): string[] => {
  const real = realName(person)
  return real === null ? [] : [real]
}

/** A crew row's player, in the shape the helpers above read. */
export const playerOf = (assignment: {
  playerDiscordName: string | null
  playerName: string | null
  playerEmail: string
}): Named => ({ discordName: assignment.playerDiscordName, name: assignment.playerName, email: assignment.playerEmail })
